var giftcard = null;
var giftcard_data = {};
var giftcard_hasInit = false;
var giftcard_locale = GIFTCARD_LOCALE_DEFAULT;
var variants = [];
var already_checkout = false;

var start_duration = Date.now();

var typewriter_hasInit = false;

var amount_options = [];
var amount_index = 0;

var sticker_swiper = null, video_swiper = null, product_swiper = null, amount_swiper = null;
var values = {
  productId: '',
  second_productId: '',
  name: '',
  message: '',
  amount: '50',
  email: '',
  sticker_swiper_index: 0, 
  video_swiper_index: 0, 
  product_swiper_index: 0, 
  amount_swiper_index: 0,
  unique_code: '',
};

var stickers = [];
var sticker_colors = {};

var metafields = {};
var collection_metafield__slogan_overlay_edges = [];
var slogan_bg_color = "";
var slogan_css_filter = "";
var rootCollection = {};

var showAlertBeforeClose = false;

var messages = {};
var theme_colors = [];
var selectedColors = {};
var selected_color_index = 0;

var temp_slogan_image_1 = '';
var temp_slogan_image_2 = null;
var sticker_urls_2 = [];

$('#preview-voucher-text-to-click').hide();

/** 
* COLLECTION
*/
$('.collection-item').on('click', function () {
  $('#products').html(''); // RESET PRODUCT LISTS
  $('.swiper-products .swiper-wrapper').html(''); // RESET PRODUCT LIST SWIPER
  $('.swiper-videos .swiper-wrapper').html(''); // RESET VIDEO LISTS
  
  var id = $(this).data('id');
  var gid = `gid://shopify/Collection/${id}`;
  
  $.ajax({
    url: `/api/${SHOPIFY_API_VERSION}/graphql.json`,
    method: 'POST',
    contentType: "application/json",
    headers: {
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
    },
    data: JSON.stringify({
      "query": 'query getCollectionById($id: ID!) { collection(id: $id) { title products(first: 20) { nodes { id title variants(first: 20) { nodes { id title } } featuredImage { width height url } metafields( identifiers: [{ namespace: "custom", key: "giftcard_slogan_image" }, { namespace: "custom", key: "giftcard_slogan_image_2" }, { namespace: "custom", key: "giftcard_second_product" }] ) { key value type reference { ... on MediaImage { image { width height url } } } } } } metafields(identifiers: [{ namespace: "custom", key: "giftcard_object" }]) { id type value reference { ... on Metaobject { id type fields { key type value reference { ... on MediaImage { image { width height url } } } references(first: 10) { edges { node { ... on Metaobject { id type fields { key type value reference { ... on Metaobject { id type fields { key type value } } } } } ... on MediaImage { image { width height url } } ... on Video { previewImage { width height url } sources { width height url } } } } } } } } } } }',
      "variables": {"id": gid}
    }),
    success: function(response) {
      showAlertBeforeClose = true;
      
      rootCollection = response.data.collection;
      var collection = response.data.collection;
      var collection_metafields = collection.metafields[0];
      var collection_metafield__fields = collection_metafields ? collection_metafields.reference.fields : null;
      
      var collection_metafield__colors = collection_metafield__fields ? collection_metafield__fields.filter((field) => field.key == "colors") : null;
      var collection_metafield__colors_string = collection_metafield__colors ? collection_metafield__colors[0].value : null;
      var collection_metafield__colors_json = collection_metafield__colors_string ? JSON.parse(collection_metafield__colors_string) : null;
      var background_of_product_item = collection_metafield__colors_json ? collection_metafield__colors_json[0].slogan.tile[0] : null;
      theme_colors = collection_metafield__colors_json;
      selectedColors = theme_colors[0];

      var collection_metafield__messages = collection_metafield__fields ? collection_metafield__fields.filter((field) => field.key == "message") : null;
      var collection_metafield__messages_value = collection_metafield__messages && collection_metafield__messages.length
        ? collection_metafield__messages[0].value : null;
      var collection_metafield__messages_json = collection_metafield__messages_value ? JSON.parse(collection_metafield__messages_value) : null;
      messages = collection_metafield__messages_json;

      var collection_metafield__slogan_overlay_active = collection_metafield__fields ? collection_metafield__fields.filter((field) => field.key == "slogan_overlay_active_web") : null; 
      var slogan_overlay_active = collection_metafield__slogan_overlay_active && collection_metafield__slogan_overlay_active.length 
        ? collection_metafield__slogan_overlay_active[0].value : 0;
        
      var collection_metafield__slogan_overlay = collection_metafield__fields ? collection_metafield__fields.filter((field) => field.key == "slogan_overlay") : null; 
      collection_metafield__slogan_overlay_edges = collection_metafield__slogan_overlay && collection_metafield__slogan_overlay.length 
        ? collection_metafield__slogan_overlay[0].references.edges : "";
      var collection_metafield__slogan_overlay_url = collection_metafield__slogan_overlay_edges && collection_metafield__slogan_overlay_edges.length 
        ? collection_metafield__slogan_overlay_edges[0].node.image.url : "";
      var collection_metafield__slogan_overlay_url_active = collection_metafield__slogan_overlay_edges && collection_metafield__slogan_overlay_edges.length 
        ? collection_metafield__slogan_overlay_edges[slogan_overlay_active].node.image.url : "";

      
      var collection_metafield__slogan_bg_color = collection_metafield__fields ? collection_metafield__fields.filter((field) => field.key == "slogan_bg_color") : null;
      slogan_bg_color = collection_metafield__slogan_bg_color && collection_metafield__slogan_bg_color.length 
        ? collection_metafield__slogan_bg_color[0].value : "";

      var collection_metafield__slogan_css_filter = collection_metafield__fields ? collection_metafield__fields.filter((field) => field.key == "slogan_css_filter") : null;
      slogan_css_filter = collection_metafield__slogan_css_filter && collection_metafield__slogan_css_filter.length 
        ? collection_metafield__slogan_css_filter[0].value : "";

      var collection_metafield__stickers = collection_metafield__fields ? collection_metafield__fields.filter((field) => field.key == "stickers") : null; 
      var collection_metafield__stickers_edges = collection_metafield__stickers && collection_metafield__stickers.length
        ? collection_metafield__stickers[0].references.edges : null;
      var collection_metafield__stickers_image = collection_metafield__stickers_edges && collection_metafield__stickers_edges.length
        ? collection_metafield__stickers_edges[0].node.image : null;
      var collection_metafield__stickers_image_url = collection_metafield__stickers_image ? collection_metafield__stickers_image.url : null;

      var collection_metafield__videos = collection_metafield__fields ? collection_metafield__fields.filter((field) => field.key == "videos") : null; 
      var collection_metafield__videos_edges = collection_metafield__videos && collection_metafield__videos.length
        ? collection_metafield__videos[0].references.edges : null;
      var collection_metafield__videos_thumbnail = collection_metafield__videos_edges && collection_metafield__videos_edges.length
        ? collection_metafield__videos_edges[0].node.previewImage.url : "";
      var collection_metafield__videos_sources = collection_metafield__videos_edges && collection_metafield__videos_edges.length
        ? collection_metafield__videos_edges[0].node.sources : null;

      var collection_metafield__video_urls = [];
      if (collection_metafield__videos_edges && collection_metafield__videos_edges.length) {
        collection_metafield__videos_edges.forEach(function (edge, index) {
          edge.node.sources.forEach(function (item) {
            if (item.url.slice(-4) == ".mp4") {
              collection_metafield__video_urls[index] = item.url ?? "";
            }
          });
        });
      }

      metafields = {
        colors: collection_metafield__colors_json,
        slogan_overlay: collection_metafield__slogan_overlay_url,
        stickers: collection_metafield__stickers_image_url,
        videos: collection_metafield__video_urls
      };
      localStorage.setItem('create-voucher__metafields', JSON.stringify(metafields));

      var colors_html = '';
      var colors = collection_metafield__colors_json;
      colors.forEach(function(item, index) {
        var active = index == 0 ? 'active' : '';
        colors_html += `
          <button type="button" class="btn btn-change-color ${active}" data-index="${index}">
            <img src="${item.icon}" alt="..." width="" height="" />
          </button>
        `
      });
      $('.preview-voucher-actions').html(colors_html);            
      
      var videos = collection_metafield__video_urls;
      if (videos.length) {
        var video_html = "";
        videos.forEach(function(item, index) {
          if (index == 0) {
            $('input[name="video"]').val(item);
            
            var order = {video: item};
            localStorage.setItem('create-voucher__order', JSON.stringify(order));
          }
          
          video_html += `
            <div class="swiper-slide">
              <video muted loop autoplay playsinline id="gift-video-${index}" class="gift-video">
                <source src="${item}" type="video/mp4">
              </video>
            </div>
          `;
        });
        $('.swiper-videos .swiper-wrapper').html(video_html);
        video_swiper_init();
      }

      stickers = collection_metafield__stickers_edges;
      if (stickers.length) {
        var sticker_html = "";
        stickers.forEach(function(item, index) {
          var sticker_image = item.node.image.url;
          
          if (index == 0) {
            $('input[name="sticker"]').val(sticker_image);
            
            metafields = {...metafields, stickers: sticker_image};
            localStorage.setItem('create-voucher__metafields', JSON.stringify(metafields));
          }

          sticker_html += `
            <div class="swiper-slide">
              <div class="swipper-sticker-wrapper" style="background-color:${selectedColors.sticker.tile[0]};border-color:${selectedColors.sticker.border[0]}">
                <img src="${sticker_image}" alt="..." width="" height="" class="swiper-sticker-image" />
              </div>
            </div>
          `;
        });
        $('.swiper-sticker .swiper-wrapper').html(sticker_html);
        sticker_swiper_init();
      }

      // ==============================
      // PRELOAD ASSETS IN PIXI
      var filtered_sticker_urls_1 = stickers.filter((item, index) => index == 0);
      var filtered_sticker_urls_2 = stickers.filter((item, index) => index > 0);
      var sticker_urls_1 = filtered_sticker_urls_1.map((item, index) => item.node.image.url);
      sticker_urls_2 = filtered_sticker_urls_2.map((item, index) => item.node.image.url);

      var filtered_video_urls_1 = videos.filter((item, index) => index == 0);
      var filtered_video_urls_2 = videos.filter((item, index) => index > 0);
      var video_urls_1 = filtered_video_urls_1.map((item, index) => item );
      var video_urls_2 = filtered_video_urls_2.map((item, index) => item );

      giftcard = new Giftcard();
      giftcard.preloadAssets([
        sticker_urls_1[0],
      ]);

      // ==============================
      
      var products = collection.products.nodes;
      var elmt_html = "";
      var swip_product_html = "";
      if (products.length) {
        var itemIndex = 0;
        products.forEach(function(item, index) {
          let giftcard_second_product = item.metafields[2];
          if (giftcard_second_product) {
            var item_metafields = item.metafields[0];
            var giftcard_slogan_image = item_metafields ? item_metafields.reference.image.url : "";
            var giftcard_slogan_image_2 = item.metafields[1] ? item.metafields[1].reference.image.url : "";
            var giftcard_slogan_overlay = collection_metafield__slogan_overlay_url;
            elmt_html += `
              <div onclick="product_item_clicked(${itemIndex}, '${item.id}', '${giftcard_second_product.value}', '${item.title}', '${giftcard_slogan_image}', '${giftcard_slogan_overlay}', '${background_of_product_item ?? '#cc081d'}', '${giftcard_slogan_image_2}')" 
                data-id="${item.id}" 
                data-index="${itemIndex}"
                data-title="${item.title}"
                data-slogan-image="${giftcard_slogan_image}" 
                data-slogan-image-2="${giftcard_slogan_image_2}"
                data-slogan-overlay="${giftcard_slogan_overlay}" 
                data-background="${background_of_product_item ?? '#cc081d'}"
                data-second-productid="${giftcard_second_product.value}"
                class="product-item product-item-${slogan_bg_color.replace("#", "")}"
              >
                <div class="product-item-image">
                  <img srcset="${giftcard_slogan_image}" src="${giftcard_slogan_image}" alt="..." height="" width="" loading="lazy" class="product-item-slogan" style="filter:${slogan_css_filter}" />
                  <img srcset="${collection_metafield__slogan_overlay_url_active}" src="${collection_metafield__slogan_overlay_url_active}" alt="..." height="" width="" loading="lazy" class="product-item-slogan-overlay" />
                </div>
              </div>
            `;
  
            swip_product_html += `
              <div class="swiper-slide"
                data-id="${item.id}" 
                data-index="${itemIndex}"
                data-title="${item.title}"
                data-slogan-image="${giftcard_slogan_image}" 
                data-slogan-image-2="${giftcard_slogan_image_2}"
                data-slogan-overlay="${giftcard_slogan_overlay}" 
                data-background="${background_of_product_item ?? '#cc081d'}" 
                data-second-productid="${giftcard_second_product.value}"
              >
                <img src="${giftcard_slogan_image}" alt="..." height="" width="" />
              </div>
            `;
            $('.swiper-products .swiper-wrapper').html(swip_product_html);
            itemIndex++;

            var style = document.querySelector('body').style;
            style.setProperty('--slogan-background', slogan_bg_color);
          }
        });
        $('#products').html(elmt_html);
        product_swiper_init();
      } else {
        $('#products').html("<p>Product is empty.</p>");
      }
      
      $('#collections-section').hide();
      $('#products-section').show();

      localStorage.setItem('create-voucher__collection', gid);
      localStorage.setItem('create-voucher-steps', 'products');
    },
    errors: function(err) {
      console.log(err);
    }
  });
});
/** ./END collection */

/** 
* Event onClick in product item
*/
$('.product-item').on('click', function () {
  var id = $(this).data('id');
  var title = $(this).data('title');
  var slogan_image = $(this).data('slogan-image');
  var slogan_overlay = $(this).data('slogan-overlay');
  var background = $(this).data('background');
  var secondId = $(this).data('second-productid');
  product_item_clicked(0, id, secondId, title, slogan_image, slogan_overlay, background);
});

$('#form-product-submit').on('submit', function(e) {
  e.preventDefault();
  
  var product = $('#product').val();
  localStorage.setItem('create-voucher__product', JSON.stringify(products));

  let parsedProduct = JSON.parse(product);

  // values.product_id = normalizeProductId(parsedProduct.id);
  values.product_id = parsedProduct.id;
  giftcard.changeSource("slogan", parsedProduct.slogan.image);

  temp_slogan_image_1 = parsedProduct.slogan.image;
  temp_slogan_image_2 = parsedProduct.slogan.image2;
  
  if (temp_slogan_image_2 && selected_color_index == 1) {
    giftcard.changeSource('slogan2', temp_slogan_image_2);
    giftcard_data.slogan.image2 = temp_slogan_image_2;
  } else {
    giftcard.changeSource('slogan_overlay', collection_metafield__slogan_overlay_edges[selected_color_index].node.image.url);
    giftcard_data.slogan.image2 = undefined;
  }

  // sendDataToMicrosite();
  
  $('#forms-wrapper').css('pointer-events', 'none');
  $('#preview-voucher').show();
  $('.preview-voucher-actions').show();
  $('.preview-voucher-actions-wrapper').show();
  
  $('#form-product-section').addClass('animate__flipOutY')
    .removeClass('animate__flipInY');

  setTimeout(function() {
    $('#form-product-section').hide();
    $('#preview-voucher-text-to-click').show();
    $('#preview-voucher-text-to-click').css('visibility', 'visible');
    $('#preview-voucher').addClass('animate__flipInY')
      .removeClass('animate__flipOutY');
  }, 400);
});

function product_swiper_init() {
// $(function() {
  product_swiper = new Swiper(".swiper-products", {
    pagination: {
      el: ".swiper-products .swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-products .swiper-button-next",
      prevEl: ".swiper-products .swiper-button-prev",
    },
    loop: true
  });
  
  product_swiper.on('slideChange', function() {
    // var index = product_swiper.realIndex;
    var index = product_swiper.activeIndex;
    var slideActive = product_swiper.slides[index];

    var id = $(slideActive).data('id');
    var title = $(slideActive).data('title');
    var slogan_image = $(slideActive).data('slogan-image');
    var slogan_image_2 = $(slideActive).data('slogan-image-2');
    var slogan_overlay = $(slideActive).data('slogan-overlay');
    var background = $(slideActive).data('background');
    var secondProductId = $(slideActive).data('second-productid');
  
    if (id) {
      var products = {
        id, 
        title, 
        slogan: {
          image: slogan_image, 
          image2: slogan_image_2,
          overlay: slogan_overlay
        }, 
        background
      };
      localStorage.setItem('create-voucher__product', JSON.stringify(products));
      $('#form-product-submit input[name="product"]').val(JSON.stringify(products)); 

      values.second_productId = secondProductId;
    }

    // if (!product_swiper.isEnd) {
    //   $('.swiper-products .swiper-button-next').removeClass('swiper-button-disabled'); 
    // }
  });
// });
}

function product_item_clicked(index, id, second_productId, title, slogan_image, slogan_overlay, background, slogan_image_2 = null) {
  try {
    if (!typewriter_hasInit) {
      typewriter_hasInit = true;
      
      $('.form-control-autotyping').placeholderTypewriter({
        text: PLACEHOLDER_TEXT
      });
    }
  }
  catch(err) {
    console.log(err.message);
  }
  
  temp_slogan_image_1 = slogan_image;
  temp_slogan_image_2 = slogan_image_2;
  
  var products = {
    id, 
    title, 
    slogan: {
      image: slogan_image, 
      overlay: slogan_overlay
    }, 
    background
  };
  localStorage.setItem('create-voucher__product', JSON.stringify(products));
  localStorage.setItem('create-voucher-steps', 'form-name-submit');

  $('#form-product-submit input[name="product"]').val(JSON.stringify(products));
  product_swiper.slideTo(index);

  // GSAP
  $('.product-item').css('z-index', '');
  var el = $(`.product-item[data-index="${index}"]`);
  $(el).css('z-index', 10);
  $('#products').css('pointer-events', 'none');

  var tl = gsap.timeline();
  tl
    .to(el, { 
      scale: 1.5, 
      opacity: 0.9, 
      duration: 0.3,
      ease: 'circ.out',
      onComplete: function() {
        $('.product-item').css({
          'z-index': '',
          'opacity': '',
          'transform': '',
        })
        $('#products-section').hide();
        $('#giftcard-section').show();
        $('#form-name-section').show();
        $('#products').css('pointer-events', '');
      } 
    })
    .add('step-2-in')
    .from('#giftcard-wrapper-outer', {
      scale: 1.2, 
      opacity: 0.9,
      duration: 0.3,
      ease: 'circ.out',
    }, 'step2-in')
    .from('#form-name-section .form-label', {
      scale: 0.25,
      opacity: 0.5,
      duration: 0.5,
      // ease: 'elastic.out',
      onComplete: function() {
        giftcard.preloadAssets(sticker_urls_2[1]);
      }
    }, 'step2-in');
  values.product_id = id;
  values.second_productId = second_productId;
  values.product_swiper_index = index;
}

function backIn_product() {
  $('#collections-section').show();
  $('#products-section').hide();
}

function backIn_product_card() {
  product_swiper.slideTo(values.product_swiper_index);
  
  $('#preview-voucher').show();
  $('.preview-voucher-actions').show();
  $('.preview-voucher-actions-wrapper').show();
  $('#forms-wrapper').css('pointer-events', 'none');

  $('#form-product-section').addClass('animate__flipOutY')
    .removeClass('animate__flipInY');

  setTimeout(function() {
    $('#form-product-section').hide();
    $('#preview-voucher-text-to-click').show();
    $('#preview-voucher-text-to-click').css('visibility', 'visible');
    $('#preview-voucher').addClass('animate__flipInY')
      .removeClass('animate__flipOutY');
  }, 400);
}
/** ./END product */


/** NAME */
$('#form-name-submit').on('submit', function(e) {
  e.preventDefault();
  
  var name = $('#name').val();
  var order = JSON.parse(localStorage.getItem('create-voucher__order'));
  order = { ...order, name };
  values.name = name;
  
  localStorage.setItem('create-voucher__order', JSON.stringify(order));
  localStorage.setItem('create-voucher-steps', 'form-amount-submit');

  if (giftcard_hasInit) {
    giftcard.changeText('name', name);
    giftcard_data.recipient = name;
    // sendDataToMicrosite();

    $('#forms-wrapper').css('pointer-events', 'none');
    $('.preview-voucher-actions').show();
    $('.preview-voucher-actions-wrapper').show();
    $('#form-name-section').addClass('animate__flipOutY')
      .removeClass('animate__flipInY');

    setTimeout(function() {
      $('#form-name-section').hide();
      $('#preview-voucher-text-to-click').show();
      $('#preview-voucher-text-to-click').css('visibility', 'visible');
      $('#preview-voucher').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    }, 400);
  } else {
    $('#form-name-section').hide();
    $('#form-amount-section').show();
    giftcard.preloadAssets(sticker_urls_2[2]);
  }
});

function backIn_name() {
  if (giftcard_hasInit) {
    $('input[name="name"]').val(values.name);
    $('.preview-voucher-actions').show();
    $('.preview-voucher-actions-wrapper').show();
    $('#forms-wrapper').css('pointer-events', 'none');
    
    $('#form-name-section').addClass('animate__flipOutY')
      .removeClass('animate__flipInY');

    setTimeout(function() {
      $('#form-name-section').hide();
      $('#preview-voucher-text-to-click').show();
      $('#preview-voucher-text-to-click').css('visibility', 'visible');
      $('#preview-voucher').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    }, 400);
  } else {
    $('#form-name-section').hide();
    $('#products-section').show();
    $('#giftcard-section').hide();
  }
}

$(function() {
  $('.form-control-uppercase').on('input', function () {
    $(this).val(this.value.toUpperCase());
    $('.form-typing-count span').html(this.value.length);
  });

  $('input[name="name"]').on('input', function() {
    var value = $(this).val();

    if (value.length) {
      $('#form-name-section button[type="submit"]').removeAttr('disabled');
    } else {
      $('#form-name-section button[type="submit"]').attr('disabled', 'disabled');
    }
  });
});
/** ./END */


/** AMOUNT */
$('#form-amount-submit').on('submit', function(e) {
  e.preventDefault();
  
  var amount = $('#amount').val();
  var order = JSON.parse(localStorage.getItem('create-voucher__order'));
  order = {...order, amount};

  values.amount = amount;
  
  localStorage.setItem('create-voucher__order', JSON.stringify(order));
  localStorage.setItem('create-voucher-steps', 'form-message-submit');

  if (giftcard_hasInit) {
    let normalizedAmount = normalizeVoucherAmount(amount);
    giftcard.changeText('voucher', normalizedAmount);
    giftcard_data.voucher.amount = normalizedAmount;
    // sendDataToMicrosite();

    $('#forms-wrapper').css('pointer-events', 'none');
    $('.preview-voucher-actions').show();
    $('.preview-voucher-actions-wrapper').show();
    $('#form-amount-section').addClass('animate__flipOutY')
      .removeClass('animate__flipInY');

    setTimeout(function() {
      $('#form-amount-section').hide();
      $('#preview-voucher-text-to-click').show();
      $('#preview-voucher-text-to-click').css('visibility', 'visible');
      $('#preview-voucher').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    }, 400);
  } else {
    $('#form-amount-section').hide();
    $('#form-message-section').show();
    for (let i = 3; i < sticker_urls_2.length; i++) {
      giftcard.preloadAssets([sticker_urls_2[i]]);
    }
  }

});

function backIn_amount() {
  if (giftcard_hasInit) {
    amount_swiper.slideTo(values.amount_swiper_index);
    animate_gift_card_zoom(values.amount_swiper_index);
    set_width_value(parseInt(values.amount_swiper_index) * 11);

    $('.preview-voucher-actions').show();
    $('.preview-voucher-actions-wrapper').show();
    $('#forms-wrapper').css('pointer-events', 'none');
    
    $('#form-amount-section').addClass('animate__flipOutY')
      .removeClass('animate__flipInY');

    setTimeout(function() {
      $('#form-amount-section').hide();
      $('#preview-voucher-text-to-click').show();
      $('#preview-voucher-text-to-click').css('visibility', 'visible');
      $('#preview-voucher').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    }, 400);
  } else {
    $('#form-amount-section').hide();
    $('#form-name-section').show();
  }
}

function set_width_value(value) {
  $('#amount-range').removeClass(function (index, className) {
    return (className.match(/(^|\s)w-\S+/g) || []).join(' ');
  });
  $('#amount-range').addClass(`w-${value}`);
}

function animate_gift_card_zoom(index) {
  if (index >= AMOUNT_EXPLODE_INDEX) {
    $('.gift-image').hide();
    $('.gift-image-lottie').show();
    $('.gift-image-lottie').get(0).play();
  } else {
    $('.gift-image').show();
    $('.gift-image-lottie').hide();
    $('.gift-image-lottie').get(0).stop();  
  }

  let w = 80 + (40 * index / (AMOUNT_VALUES.length - (AMOUNT_VALUES.length - AMOUNT_EXPLODE_INDEX)));
  $('.gift-image').css('width', `${w}px`);
}

$(function() {
  $('.swiper-amount-options-wrapper').html(voucher_amounts_html);

  $('#amount-range').attr({
    max: AMOUNT_VALUES.length - 1,
    value: parseInt(AMOUNT_VALUES.length / 2),
    class: AMOUNT_INPUT_INITIAL_CLASS,
  });
  
  amount_swiper = new Swiper(".swiper-amount", {
    slidesPerView: 3,
    spaceBetween: 0,
    centeredSlides: true,
    initialSlide: AMOUNT_INITIAL_INDEX,
    navigation: {
      nextEl: ".swiper-amount-wrapper .swiper-button-next",
      prevEl: ".swiper-amount-wrapper .swiper-button-prev",
    }
  });
  
  amount_swiper.on('slideChange', function () {
    var index = amount_swiper.realIndex;
    
    $('#amount-range').val(index);
    $('input[name="amount"]').val(AMOUNT_VALUES[index]);

    animate_gift_card_zoom(index);
    set_width_value(parseInt(index / (AMOUNT_VALUES.length - 1) * 100));
  });

  $('#amount-range').on('input', function() {
    animate_gift_card();
  });

  function animate_gift_card() {
    var index = $('#amount-range').val();
      
    amount_swiper.slideTo(index);
    animate_gift_card_zoom(index);
    set_width_value(parseInt(index / (AMOUNT_VALUES.length - 1) * 100));
      
    $('input[name="amount"]').val(AMOUNT_VALUES[index]);
  }
  animate_gift_card();
})
/** ./END */


/** 
 * MESSAGE 
 */
$('#form-message-submit').on('submit', function(e) {
  e.preventDefault();
  
  var message = $('#message').val();
  var order = JSON.parse(localStorage.getItem('create-voucher__order'));
  order = {...order, message};

  values.message = message;
  
  localStorage.setItem('create-voucher__order', JSON.stringify(order));
  localStorage.setItem('create-voucher-steps', 'form-video-submit');

  var metafields = localStorage.getItem('create-voucher__metafields');
  var metafields_JSON = metafields ? JSON.parse(metafields) : null;
  var metafields_colors = metafields_JSON ? metafields_JSON.colors[0] : null;

  var products = localStorage.getItem('create-voucher__product');
  var products_JSON = products ? JSON.parse(products) : null;
  
  var order2 = localStorage.getItem('create-voucher__order');
  var order_JSON = order2 ? JSON.parse(order2) : null;
  
  $('#forms-wrapper').css('pointer-events', 'none');
  $('.create-voucher-page').addClass('bg-white');
  $('.preview-voucher-actions').show();
  $('.preview-voucher-actions-wrapper').show();
  
  if (!giftcard_hasInit) {
    giftcard_data = {
      colors: {
          background: metafields_colors.background,
          slogan: metafields_colors.slogan,
          voucher: metafields_colors.voucher,
          sticker: metafields_colors.sticker,
          message: metafields_colors.message,
      },
      slogan: products_JSON.slogan,
      slogan_overlay: metafields_JSON.slogan_overlay,
      sticker: {
          gif: metafields_JSON.stickers,
      },
      video: order_JSON.video,
      recipient: order_JSON.name,
      voucher: {
          amount: order_JSON.amount
      },
      message,
      voucher_variant: WGS_VOUCHER_VARIANT,
      website_id: WGS_WEBSITE_ID,
      website_locale: Shopify.locale,
      locale: giftcard_locale,
    }
    giftcard.inputData = giftcard_data;
    giftcard.init();
    giftcard.generateTiles();
    // giftcard.loadVideoFromVideoElement(document.getElementsByClassName("gift-video")[0]);
    giftcard.loadVideoFromVideoElement(document.getElementById("gift-video-0"));
    giftcard.entryAnimation();
    giftcard_hasInit = true;
    $('.giftcard-wrapper').trigger('resize');
    
    // sendDataToMicrosite();

    $('#form-message-section').hide();
    $('#preview-voucher-text-to-click').show();
    $('#preview-voucher-text-to-click').css('visibility', 'visible');
    $('#preview-voucher').show();
  } else {
    giftcard_data.message = message;
    
    $('.preview-voucher-actions').show();
    $('.preview-voucher-actions-wrapper').show();
    $('#form-message-section').addClass('animate__flipOutY')
      .removeClass('animate__flipInY');

    setTimeout(function() {
      $('#form-message-section').hide();
      $('#preview-voucher-text-to-click').show();
      $('#preview-voucher-text-to-click').css('visibility', 'visible');
      $('#preview-voucher').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    }, 400);
  }
});

function backIn_message() {
  if (giftcard_hasInit) {
    $('.preview-voucher-actions').show();
    $('.preview-voucher-actions-wrapper').show();
    $('#forms-wrapper').css('pointer-events', 'none');
    
    $('#form-message-section').addClass('animate__flipOutY')
      .removeClass('animate__flipInY');

    setTimeout(function() {
      $('#form-message-section').hide();
      $('#preview-voucher-text-to-click').show();
      $('#preview-voucher-text-to-click').css('visibility', 'visible');
      $('#preview-voucher').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    }, 400);
  } else {
    $('#form-message-section').hide();
    $('#form-amount-section').show();
  }
}

$(function () {
  $('.form-control-area').on('input', function () {
    $('.form-msg-typing-count span').html(this.value.length);
  });

  $('.btn-msg-action-01').on('click', function() {
    var msgTemplate = messages.friends_family ?? "";
    $('.form-control-area').val(msgTemplate);
    $('.form-msg-typing-count span').html($('.form-control-area').val().length);

    var value = $('textarea[name="message"]').val();
    if (value.length) {
      $('#form-message-section button[type="submit"]').removeAttr('disabled');
    } else {
      $('#form-message-section button[type="submit"]').attr('disabled', 'disabled');
    }
  });

  $('.btn-msg-action-02').on('click', function() {
    var msgTemplate = messages.neutral ?? "";
    $('.form-control-area').val(msgTemplate);
    $('.form-msg-typing-count span').html($('.form-control-area').val().length);

    var value = $('textarea[name="message"]').val();
    if (value.length) {
      $('#form-message-section button[type="submit"]').removeAttr('disabled');
    } else {
      $('#form-message-section button[type="submit"]').attr('disabled', 'disabled');
    }
  });

  $('textarea[name="message"]').on('input', function() {
    var value = $(this).val();
    if (value.length) {
      $('#form-message-section button[type="submit"]').removeAttr('disabled');
    } else {
      $('#form-message-section button[type="submit"]').attr('disabled', 'disabled');
    }
  });
});
/** ./END */


/** VIDEOS */
$('#form-video-submit').on('submit', function(e) {
  e.preventDefault();
  
  var video = $('#video').val();
  var order = JSON.parse(localStorage.getItem('create-voucher__order'));
  order = {...order, video};
  
  localStorage.setItem('create-voucher__order', JSON.stringify(order));
  localStorage.setItem('create-voucher-steps', 'form-video-submit');

  // giftcard.changeSource("video", video);
  // giftcard.loadVideoFromVideoElement(document.getElementsByClassName("gift-video")[video_swiper.realIndex]);
  giftcard.loadVideoFromVideoElement(document.getElementById("gift-video-" + video_swiper.realIndex));
  giftcard_data.video = video;
  // sendDataToMicrosite();

  $('#forms-wrapper').css('pointer-events', 'none');
  $('#preview-voucher').show();
  $('.preview-voucher-actions').show();
  $('.preview-voucher-actions-wrapper').show();
  
  $('#form-video-section').addClass('animate__flipOutY')
    .removeClass('animate__flipInY');

  setTimeout(function() {
    $('#form-video-section').hide();
    $('#preview-voucher-text-to-click').show();
    $('#preview-voucher-text-to-click').css('visibility', 'visible');
    $('#preview-voucher').addClass('animate__flipInY')
      .removeClass('animate__flipOutY');
  }, 400);
});

function backIn_video() {
  video_swiper.slideTo(values.video_swiper_index);
  
  $('#preview-voucher').show();
  $('.preview-voucher-actions').show();
  $('.preview-voucher-actions-wrapper').show();
  $('#forms-wrapper').css('pointer-events', 'none');

  $('#form-video-section').addClass('animate__flipOutY')
    .removeClass('animate__flipInY');

  setTimeout(function() {
    $('#form-video-section').hide();
    $('#preview-voucher-text-to-click').show();
    $('#preview-voucher-text-to-click').css('visibility', 'visible');
    $('#preview-voucher').addClass('animate__flipInY')
      .removeClass('animate__flipOutY');
  }, 400);
}

function video_swiper_init() {
// $(function() {
  video_swiper = new Swiper(".swiper-videos", {
    pagination: {
      el: ".swiper-videos .swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-videos .swiper-button-next",
      prevEl: ".swiper-videos .swiper-button-prev",
    },
    loop: true
  });

  video_swiper.on('slideChange', function () {
    var index = video_swiper.realIndex;
    
    var metafield_storage = localStorage.getItem('create-voucher__metafields');
    var metafield_storage_json = metafield_storage ? JSON.parse(metafield_storage) : null;

    var videos = metafield_storage_json ? metafield_storage_json.videos : null;
    if (videos.length) {
      var video = videos[index];
      $('input[name="video"]').val(video);
    }
  });
// });
}
/** ./END */


/**
* PREVIEW
*/
$(document).on('click', '.btn-change-color', function() {
  $('.btn-change-color').removeClass('active');
  $(this).addClass('active');
  
  let index = $(this).data('index');
  selectedColors = theme_colors[index];
  giftcard.setColors(selectedColors);
  giftcard.changeSource('slogan_overlay', collection_metafield__slogan_overlay_edges[index].node.image.url);
  
  giftcard_data.slogan.overlay = collection_metafield__slogan_overlay_edges[index].node.image.url;

  selected_color_index = index;
  if (temp_slogan_image_2 && selected_color_index == 1) {
    giftcard.changeSource('slogan2', temp_slogan_image_2);
    giftcard_data.slogan.image2 = temp_slogan_image_2;
  } else {
    giftcard.changeSource('slogan', temp_slogan_image_1);
    giftcard_data.slogan.image2 = undefined;
  }
});

$('#preview-voucher .btn-actions').on('click', function() {
  $('#voucher-ready-section').show();
  
  $('#giftcard-section').hide();
  $('.preview-voucher-actions').hide();
  $('.preview-voucher-actions-wrapper').hide();

  $('.giftcard-wrapper').appendTo('#voucher-ready-giftcard-wrapper');
  
  $('.giftcard-wrapper').css({borderRadius: '10px', width: '256px', height: '450px'});
  $('.giftcard-wrapper canvas').css({width: '256px', height: '450px'});

  // sendDataToMicrosite();
  giftcard.hitArea_setActive(false);
  giftcard.stopAllBumpAnimations();
});

function giftcard_tileClicked(location) {
  $('#forms-wrapper').css('pointer-events', '');
  $('#preview-voucher-text-to-click').css('visibility', '');
  
  values.name = $('input[name="name"]').val();
  // values.sticker_swiper_index = sticker_swiper.realIndex;
  // values.video_swiper_index = video_swiper.realIndex;
  // values.product_swiper_index = product_swiper.realIndex;
  // values.amount_swiper_index = amount_swiper.realIndex;

  values.sticker_swiper_index = sticker_swiper.activeIndex;
  values.video_swiper_index = video_swiper.activeIndex;
  values.product_swiper_index = product_swiper.activeIndex;
  values.amount_swiper_index = amount_swiper.activeIndex;

  $('#preview-voucher').addClass('animate__flipOutY')
    .removeClass('animate__flipInY');
  
  $('.card-form').addClass('shadow');

  setTimeout(function() {
    if (location == "name") {
      $('#form-name-section').show();
      
      $('#form-name-section').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    } else if (location == "video") {
      $('#form-video-section').show();
      video_swiper.update();
      
      // if (!video_swiper.isEnd) {
      //    $('.swiper-videos .swiper-button-next').removeClass('swiper-button-disabled'); 
      // }
      
      $('#form-video-section').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    } else if (location == "slogan") {
      $('#form-product-section').show();
      product_swiper.update();
      
      // if (!product_swiper.isEnd) {
      //    $('.swiper-products .swiper-button-next').removeClass('swiper-button-disabled'); 
      // }
      
      $('#form-product-section').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    } else if (location == "sticker") {
      $('#form-sticker-section').show();
      sticker_swiper.update();
      
      $('.swipper-sticker-wrapper').css({
        "background-color": selectedColors.sticker.tile[0],
        "border-color": selectedColors.sticker.border[0]
      });
      
      $('#form-sticker-section').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    } else if (location == "message") {
      $('#form-message-section').show();
      
      $('#form-message-section').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    } else if (location == 'voucher') {
      $('#form-amount-section').show();
      amount_swiper.update();
      
      $('#form-amount-section').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    }
    $('.preview-voucher-actions').hide();
    $('.preview-voucher-actions-wrapper').hide();
    $('#preview-voucher-text-to-click').hide();
  }, 400);
}
/** ./END preview */

/**
* STICKER
*/
function backIn_sticker() {
  sticker_swiper.slideTo(values.sticker_swiper_index);
    
  $('#preview-voucher').show();
  $('.preview-voucher-actions').show();
  $('.preview-voucher-actions-wrapper').show();
  $('#forms-wrapper').css('pointer-events', 'none');

  $('#form-sticker-section').addClass('animate__flipOutY')
    .removeClass('animate__flipInY');

  setTimeout(function() {
    $('#form-sticker-section').hide();
    $('#preview-voucher-text-to-click').show();
    $('#preview-voucher-text-to-click').css('visibility', 'visible');
    $('#preview-voucher').addClass('animate__flipInY')
      .removeClass('animate__flipOutY');
  }, 400);
} 

$(function() {
  $('#form-sticker-submit').on('submit', function(e) {
    e.preventDefault();

    var sticker = $('#sticker').val();
    var metafields = JSON.parse(localStorage.getItem('create-voucher__metafields'));
    metafields = {...metafields, stickers: stickers};
    
    localStorage.setItem('create-voucher__metafields', JSON.stringify(metafields));
  
    giftcard.changeSource('sticker', sticker);
    giftcard_data.sticker.gif = sticker;
    // sendDataToMicrosite();

    $('#forms-wrapper').css('pointer-events', 'none');
    $('#preview-voucher').show();
    $('.preview-voucher-actions').show();
    $('.preview-voucher-actions-wrapper').show();
    
    $('#form-sticker-section').addClass('animate__flipOutY')
      .removeClass('animate__flipInY');

    setTimeout(function() {
      $('#form-sticker-section').hide();
      $('#preview-voucher-text-to-click').show();
      $('#preview-voucher-text-to-click').css('visibility', 'visible');
      $('#preview-voucher').addClass('animate__flipInY')
        .removeClass('animate__flipOutY');
    }, 400);
  });

});

function sticker_swiper_init() {
// $(function() {
  sticker_swiper = new Swiper(".swiper-sticker", {
    pagination: {
      el: ".swiper-sticker .swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-sticker .swiper-button-next",
      prevEl: ".swiper-sticker .swiper-button-prev",
    },
    loop: true
  });
  
  sticker_swiper.on('slideChange', function () {
    var index = sticker_swiper.realIndex;
    var sticker = stickers.length ? stickers[index] : null;
    $('input[name="sticker"]').val(sticker.node.image.url);
  });
// });
}
/** ./END sticker */


/** VOUCHER READY */
$(function() {
  $('#voucher-ready-submit').on('submit', function(e) {
    e.preventDefault();

    console.time('timer FR');

    sendDataToMicrosite();
  });  
});

function backIn_voucher_ready() {
  giftcard.hitArea_setActive(true);

  $('#voucher-ready-section').hide();
  
  $('#giftcard-section').show();
  // $('#preview-voucher-text-to-click').show();
  $('#preview-voucher-text-to-click').css('visibility', 'visible');
  $('.preview-voucher-actions').show();
  $('.preview-voucher-actions-wrapper').show();
  $('#forms-wrapper').css('pointer-events', 'none');
  
  $('.giftcard-wrapper').appendTo('#preview-voucher .card-form');

  let hwrap = '100%';
  if ($(window).width() <= 578) {
    hwrap = 'calc(100vh - 250px)';
  }
  
  $('.giftcard-wrapper').css({borderRadius: '20px', width: '100%', height: hwrap });

  let h1 = $('.giftcard-wrapper').height();
  let w1 = $('.giftcard-wrapper').width();
  $('.giftcard-wrapper canvas').css({width: w1, height: h1});

  if (already_checkout) {
    values.unique_code = '';
    already_checkout = false;
    $('.btn-addToCart').attr('disabled', '');
    $('.btn-addToCart-spinner').show();
    $('.btn-addToCart-text').hide();
  }
  
}
/** ./END */

let submitCounter = 0;
const MAX_RETRIES = 5;
const RETRY_DELAY = 1000; // 1 second delay before retry

function sendDataToMicrosite() {
  $('.max-retry-warning').addClass('hidden');
  submitCounter++;
  $('.btn-addToCart-spinner').show();
  $('.btn-addToCart-text').hide();
  $('.btn-addToCart').attr('disabled', 'disabled');

  let duration = Date.now() - start_duration;
  
  giftcard_data = {
    ...giftcard_data,
    voucher_variant: WGS_VOUCHER_VARIANT,
    locale: giftcard_locale,
    website_id: WGS_WEBSITE_ID,
    website_locale: Shopify.locale,
    duration,
  };

  const shopDomain = window.Shopify?.shop;

  $.ajax({
    headers: { 'X-API-Key': API_KEY },
    url: `${API_URL}/gift-card/save?with-upload-image=1`, 
    method: 'POST',
    data: {
      unique_code: values.unique_code,
      data: JSON.stringify(giftcard_data),
      store_domain: shopDomain
    },
    success: function(result){
      console.log('result', result);
      
      if (!result.data.unique_code) {
        if (submitCounter >= MAX_RETRIES) {
          // show error - max retries reached
          $('.btn-addToCart-spinner').hide();
          $('.btn-addToCart-text').show();
          $('.btn-addToCart').removeAttr('disabled');
          submitCounter = 0;
          $('.max-retry-warning').removeClass('hidden');
          console.error('Max retries reached. Unable to save gift card.');
        } else {
          // Wait 1 second before retry
          setTimeout(() => {
            sendDataToMicrosite();
          }, RETRY_DELAY);
        }
      } else {
        values.unique_code = result.data.unique_code;

        showAlertBeforeClose = false;
        var productVariantId = getProductVariantId();
        var data = {
          'items': [{
            'id': productVariantId,
            'quantity': 1,
            'properties': {
              'Für wen ist der Gutschein': values.name,
              'Nachricht': values.message,
              'Produkt-ID': values.unique_code,
              'Thumbnail-Image': result.shopify.data.image.url
            },
          }]
        };
        setTimeout(() => {
          
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          })
          .then(response => {
            already_checkout = true;
            console.timeEnd('timer FR');
            window.location.href ='/checkout/';
          })
          .catch((error) => {
            console.error('Error:', error);
            showAlertBeforeClose = true;
          });
        }, 1250);
      }
      
      // $('.btn-addToCart-spinner').hide();
      // $('.btn-addToCart-text').show();
      // $('.btn-addToCart').removeAttr('disabled');
    },
    error: function(xhr, status, error) {
      console.error('AJAX Error:', status, error);
      if (submitCounter >= MAX_RETRIES) {
        // show error - max retries reached
        $('.btn-addToCart-spinner').hide();
        $('.btn-addToCart-text').show();
        $('.btn-addToCart').removeAttr('disabled');
        submitCounter = 0;
        $('.max-retry-warning').removeClass('hidden');
        console.error('Max retries reached. Request failed.');
      } else {
        // Wait 1 second before retry
        setTimeout(() => {
          sendDataToMicrosite();
        }, RETRY_DELAY);
      }
    }
  });
 
}

function normalizeVoucherAmount(str) {
  str = str.replace(AMOUNT_CURRENCY_SYMBOL, '');
  str = str.trim();
  return str;
}

function normalizeProductId(str) {
  return str.replace('gid://shopify/Product/', '');
}

function normalizeProductVariantId(str) {
  return str.replace('gid://shopify/ProductVariant/', '');
}

function getProductVariantId() {
  var filteredProduct = rootCollection.products.nodes.filter((node) => {
    return node.id == values.product_id;
  });

  if (selected_color_index > 0) {
    var secondProduct = rootCollection.products.nodes.filter((node) => {
      return node.id == values.second_productId;
    });
    
    if (secondProduct.length) {
      filteredProduct = secondProduct;
    }
  }
  
  variants = filteredProduct.length ? filteredProduct[0].variants.nodes : null;

  let filteredVariant = variants.filter((variant) => {
    return Number(normalizeVoucherAmount(variant.title)) == values.amount;
  });

  return normalizeProductVariantId(filteredVariant[0].id);
}

// On screen resize, will resize the pixi visual
$(window).on('resize', function() {
  if (giftcard_hasInit) {
    giftcard.resize();
  }
});

// $(window).on('beforeunload', function(){
//   return null;
// });
